import React, { Component } from 'react';
import Text from '@dbk/ui-text';
import DisplayTime from './get-display-time';
import ReceivedAttach from './received-attach';

class ReceivedMessage extends Component {
  render = () => (
    this.props.message.attachmentId ?
      <ReceivedAttach message={this.props.message}
        downloadAttachment={this.props.downloadAttachment}
        isDownloading={this.props.isDownloading} /> :
      <div className="incoming-message">
        <Text size="normal">{this.props.message.message ? this.props.message.message : ''}</Text>
        <div className="timestamp">
          <DisplayTime
            dateAndTime={this.props.message.meta} /></div>

      </div>
  )


}
export default ReceivedMessage;
